import React from "react";
import { useExpertProfileContext } from "@limitless/expert";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";

const useCustomTheme = () => {
    const { isDarkMode } = useExpertProfileContext();
    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);

    return theme;
};

export default useCustomTheme;
